export function isNotNull<t>(value: t) {
  return value != null;
}

export function assertNotNull<t>(value: t): asserts value is NonNullable<t> {
  if (value == null) throw new Error('value is null or undefined');
}
